"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmailOpen = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18.2928932,19 L14.6661558,15.3732625 L12.9761871,16.8218071 C12.4144525,17.3032939 11.5855475,17.3032939 11.0238129,16.8218071 L9.33384425,15.3732625 L5.70710678,19 L18.2928932,19 Z M19,18.2928932 L19,11.6585389 L15.4276554,14.7205486 L19,18.2928932 Z M5,18.2928932 L8.57234464,14.7205486 L5,11.6585389 L5,18.2928932 Z M5.09041571,10.4202596 L11.6746043,16.0625505 C11.8618492,16.2230461 12.1381508,16.2230461 12.3253957,16.0625505 L18.9095841,10.4202594 L12.3292523,4.61686399 C12.1407393,4.45191512 11.8592607,4.45191512 11.6707477,4.61686399 L5.09041571,10.4202596 Z M20,19 C20,19.5522847 19.5522847,20 19,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,10.4537682 C4,10.1654056 4.12448043,9.89107962 4.34149539,9.70119153 L11.0122431,3.8642873 C11.5777821,3.36944069 12.4222179,3.36944069 12.9877569,3.8642873 L19.6585046,9.70119153 C19.8755196,9.89107962 20,10.1654056 20,10.4537682 L20,19 Z" })));
};
EmailOpen.displayName = 'EmailOpen';
exports.default = EmailOpen;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmailOpen.js.map